module.exports = __webpack_public_path__ + "img/aiqiyi.35d39ed2.jpg";